import { has } from 'lodash';

import { SampleFilterApiModel } from '../../../api/mentions/model/sample-filter-api.model';

export class SampleFilterModel {
    samplePercent?: number; // min 0, max 100
    sampleAmount?: number;
    basedOnMentionAmount?: number;

    constructor(apiModel: SampleFilterApiModel) {
        if (apiModel) {
            if (has(apiModel, 'samplePercent')) {
                this.samplePercent = apiModel.samplePercent;
            }
            if (has(apiModel, 'sampleAmount')) {
                this.sampleAmount = apiModel.sampleAmount;
            }
            if (has(apiModel, 'basedOnMentionAmount')) {
                this.basedOnMentionAmount = apiModel.basedOnMentionAmount;
            }
        }
    }
}
